import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { legacy_createStore } from 'redux';
import rootReducer from './ams/redux/rootReducer';
import { Provider } from 'react-redux';
import {SocketContext, socket} from './ams/context/socket';


const store = legacy_createStore(rootReducer)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <SocketContext.Provider value={socket}>
        <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
        </Provider>
    </SocketContext.Provider>
  
);

// <React.StrictMode> </React.StrictMode>


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
